import React from 'react'
import { localizer } from '../../Translator'

import Container from '@material-ui/core/Container'
import { TableContainer, TableHead, TableBody, TableCell } from "@material-ui/core";
import { Paper } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import { GridHeaderComponent, GridHeaderFilter } from '../common/HeaderComponentStyled.js'
import { Backdrop, CircularProgress } from "@material-ui/core"
import { Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";

import { TableRowHeaderStyled } from '../common/TableStyled.js'
import { TableStyled } from '../common/TableStyled.js'
import { SnackbarCustom } from "../Utilities/SnackbarCustom";

import DraftIcon from '@material-ui/icons/Drafts';

import OutboxCli from "../../sdk/OutboxCli";

import { DraftRow } from "./sections/DraftRow";

const DRAFT_PAGE_SIZE = 1000

export class DraftsLayout extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      drafts: [],
      pagesLoaded: 0,
      isLoading: false,
      endOfDrafts: false,
      loadDraftError: null,
      removeDraftError: null,
      uploadDraftError: null
    }
  }

  /**
   * It runs after the component output has been rendered 
   * to the DOM. Calling API to get available drafts before 
   * component mount. It gets the first 1000 drafts.
   */
  componentDidMount() {
    this.loadNextPage()
  }

  loadNextPage = () => {

    this.setState({ isLoading: true })
    
    OutboxCli.GetDrafts(DRAFT_PAGE_SIZE, this.state.pagesLoaded, true).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ loadDraftError: data.substring(data.indexOf(' ')) })
      } else {
        if (data.length > 0) {
          this.setState(previousState => ({
            drafts: [...previousState.drafts, ...data],
            pagesLoaded: previousState.pagesLoaded + 1
          }))
        }
        if (data.length < DRAFT_PAGE_SIZE) {
          this.setState({ endOfDrafts: true })
        }
        this.setState({ loadDraftError: null })
      }
      this.setState({ isLoading: false })
    })
  }

  /**
   * Creates a new an  draft.
   * It's called when the user press 'Import draft' button from draft list header component. 
  */
  addDraft = (newdrafts) => {
    newdrafts.forEach((newdraft) => {
      this.setState({ drafts: [newdraft, ...this.state.drafts], uploadDraftError: null })
    })
  }

  /**
   * Deletes an existing draft.
   * It's called when the user press 'Remove draft' button from draft list component. 
  */
  deleteDraft = (draftid) => {

    OutboxCli.RemoveDraft(draftid).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ removeDraftError: data.substring(data.indexOf(' ')) })
      } else {
        const drafts = this.state.drafts.filter(draft => draft.draftId !== draftid)
        this.setState({ drafts: drafts, removeDraftError: null })
      }
    })
  }
    
  /**
   * Handle onChange event to upload a draft. 
   * We update the component state with the response to render the child component.
   */
  handleOnChangeDraft = (event) => {
    this.setState({ isLoading: true })

    var files = event.target.files

    const formData = new FormData()
    for (const file of files) {
      formData.append('files', file)
    }

    /**
     * Uploads a draft from client file system when the user press 'Import draft' button. 
     */
    OutboxCli.UploadDrafts(formData, "").then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ uploadDraftError: data.substring(data.indexOf(' ')) })
      } else {
        this.addDraft(data)
      }
      this.setState({ isLoading: false })
    })
  }
  
  handleonClose = () => {
    this.setState({ loadDraftError: null, removeDraftError: null, uploadDraftError: null })
  }

  render() {

    return (
      <React.Fragment>
        <Container className="pl-18 pr-18 pb-12 pt-55">

          <GridHeaderComponent container direction="row" spacing={4}>
            <Grid item md={9}>
              <Typography className="typography-generic header-title"><DraftIcon className="icon-button-header" />{localizer.Documents}</Typography>
            </Grid>
            <Grid item md={3} className="text-align-right" >
              <input
                accept="application/pdf, application/msword"
                id="contained-button-file"
                multiple
                type="file"
                className="display-none"
                onChange={this.handleOnChangeDraft}
              />
              <label htmlFor="contained-button-file">
                {/* <Button className="button-generic header" variant="contained" color="primary" component="span">
                  <DescriptionIcon className="font-size-25"></DescriptionIcon>&nbsp;{localizer.Import}
                </Button>  */}
                <Button className="button-generic secondary-header" variant="contained" component="span" startIcon={<i className="fa-solid fa-plus"></i>}>
                  {localizer.NewDocument}
                </Button>
              </label>
            </Grid>
          </GridHeaderComponent>
          <GridHeaderFilter className="mt-15" container direction="row" justify="center" alignItems="center" spacing={4}>
            <Grid item md={3}>
            </Grid>
            <Grid item md={3}>
            </Grid>
            <Grid item md={3}>
            </Grid>
            <Grid item md={3}>
            </Grid>
          </GridHeaderFilter>

          <Grid container direction="row" justify="center" alignItems="center" spacing={4} className="pt-25">
            <TableContainer component={Paper}>
              <TableStyled>
                <TableHead>
                  <TableRowHeaderStyled>
                    <TableCell><Typography className="typography-generic tablerow-header">{localizer.Document}</Typography></TableCell>
                    <TableCell ><Typography className="typography-generic tablerow-header">{localizer.Description}</Typography></TableCell>
                    <TableCell ><Typography className="typography-generic tablerow-header">{localizer.Uploaded}</Typography></TableCell>
                    <TableCell ><Typography className="typography-generic tablerow-header">{localizer.User}</Typography></TableCell>
                    <TableCell ><Typography className="typography-generic tablerow-header">{localizer.Used}</Typography></TableCell>
                    <TableCell ><Typography className="typography-generic tablerow-header">{localizer.View}</Typography></TableCell>
                    <TableCell ><Typography className="typography-generic tablerow-header">{localizer.Send}</Typography></TableCell>
                    <TableCell ><Typography className="typography-generic tablerow-header">{localizer.Delete}</Typography></TableCell>
                  </TableRowHeaderStyled>
                </TableHead>
                <TableBody>
                  {this.state.drafts.map((draft) => {
                    return (
                      <DraftRow key={draft.draftId} deleteDraft={this.deleteDraft} draft={draft}/>
                    )
                  })}
                </TableBody>
              </TableStyled>
            </TableContainer>
          </Grid>
          <Grid container direction="row" spacing={4} justify="flex-end" className="pt-25">
            <Button className="button-generic primary-load-element" variant="contained" onClick={this.loadNextPage} disabled={this.state.endOfDrafts}>{localizer.LoadMore}</Button>
          </Grid>
        </Container>

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} className="zindex-100">
            <CircularProgress color="secondary" />
          </Backdrop>
        }

        {/* Deletion failure notification. */}
        <SnackbarCustom message={this.state.loadDraftError} severity="error" handleonClose={this.handleonClose}/>

        {/* Upload draft error. */}        
        <SnackbarCustom message={this.state.removeDraftError} severity="error" handleonClose={this.handleonClose}/>

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.uploadDraftError} severity="error" handleonClose={this.handleonClose}/>
      </React.Fragment>
    )
  }


}


// WEBPACK FOOTER //
// ./src/components/drafts/DraftsLayout.js